import React from "react";
import Button from "../../../../CommonElements/Button";
import OutgoingArrow from "../../../../CommonElements/OutgoingArrow";
import { useCompetition } from "../../../../context/CompetitionContext";
import { useLanguage } from "../../../../context/LanguageContext";
import { useSignupModal } from "../../../../context/SignupModalContext";
import { useTermsModal } from "../../../../context/TermsModalContext";
import heroTrophies from "../../../../assets/images/hero-trophies.svg";
import bgScreen from "../../../../assets/images/bg-screen.svg";

const ScreenDecor = ({ position }) => (
  <div className={`hero__decor hero__decor--${position}`} aria-hidden="true">
    <div className="hero__decor-inner">
      <img className="hero__decor-grid" src={bgScreen} alt="" width={1200} height={181} />
      <span className="hero__decor-flow" />
      <span className="hero__decor-ticks" />
    </div>
  </div>
);

const Hero = () => {
  const { openSignup } = useSignupModal();
  const { openTerms } = useTermsModal();
  const { t } = useLanguage();
  const { competition } = useCompetition();
  const balance = competition.startingBalance || competition.stats?.[1]?.value || "";

  return (
    <section className="hero">
      <div className="hero__bg" aria-hidden="true" />

      <div className="hero__frame">
        <ScreenDecor position="top" />
        <ScreenDecor position="bottom" />

        <div className="hero__content">
          <p className="heading--eyebrow">{t("hero.tagline")}</p>
          <h1 className="hero__title">{t("hero.title")}</h1>
          <p className="hero__subtitle">{t("hero.subtitle", { balance })}</p>
          <div className="hero__actions">
            <Button
              variant="primary"
              size="lg"
              icon={<OutgoingArrow size={18} />}
              onClick={openSignup}
            >
              {t("hero.participateNow")}
            </Button>
            <Button
              variant="secondary"
              size="lg"
              icon={<OutgoingArrow size={18} />}
              onClick={openTerms}
            >
              {t("hero.seeHowItWorks")}
            </Button>
          </div>
        </div>

        <div className="hero__media">
          <img
            src={heroTrophies}
            alt={t("hero.trophiesAlt")}
            width={569}
            height={430}
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
